import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';
import { List, ListItem, ListItemText, ListItemGraphic} from 'rmwc/List';
import ReactGA from 'react-ga';

class QuestionnaireMain extends Component{
    constructor(props) {
        super(props)
        this.state = {
            data:{
                pageStatus: ''
            }
        }
    }

    componentDidMount() {
        let data = Object.assign({}, this.state.data)
        let accessCheck = 'user/learning_resource/mc_learning_path'

        return api.getUserResponse(this.props.user.accessToken, accessCheck)
        .then((result) => {
            data.pageStatus = result.status
            this.setState({data: data})
        })


        /*<br />
        <ListItem>
            <ListItemGraphic>feedback</ListItemGraphic>
            <ListItemText><Link to="/portal/app/user/survey_user_home">Survey</Link> <br /><Typography use="caption">Let us know your thoughts!</Typography> </ListItemText>
        </ListItem> */
    }

    render(){
        let mainPageContent = (
            <Grid>
                <GridCell span = "12">
                    <Card style={{padding: '0px'}}>
                        <Grid className="opportunity-list-item">
                            <GridCell span = "11">
                                <Typography use="headline5">Quizzes and Surveys</Typography>
                            </GridCell>
                        </Grid>
                    </Card>
                </GridCell>
                <GridCell span = "12">
                    <List>
                        <ListItem>
                            <ListItemGraphic>question_answer</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/user/samplequiz_user_home">Sample Quizzes</Link></ListItemText>
                        </ListItem>
                        <ListItem>
                            <ListItemGraphic>feedback</ListItemGraphic>
                            <ListItemText><Link to="/portal/app/user/survey_user_home">Surveys</Link></ListItemText>
                        </ListItem>
                    </List>
                </GridCell>
            </Grid>
        )
        return(
            <div>
                {mainPageContent}
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireMain);


// WEBPACK FOOTER //
// ./src/views/questionnaire/QuestionnaireMain.jsx